import { ToastService } from '@atsystems/ui';

export type FeedbackToastSeverity = 'success' | 'error' | 'warning';
type ToastMessage = Parameters<ToastService['add']>[0];

const TITLES: Record<FeedbackToastSeverity, string> = {
  success: 'Success',
  error: 'Error',
  warning: 'Warning',
};

/** Feedback toasts always carry a title, as elsewhere in the app. */
export function feedbackToast(severity: FeedbackToastSeverity, detail: string): ToastMessage {
  return { severity, summary: TITLES[severity], detail };
}
